<template>
	<fragment>
		<common-header
			subname="게시판관리"
			name="게시글 상세 보기"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu :menus="sideMenus" :btnList="sideButtons"></common-side-menu>

			<section ref="container" class="container-fiuld class-making-box clearfix" v-if="article">

				<!-- 링크 이동 --> <!-- 컴포넌트 분리 필요 -->
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{sideMenus.length ? sideMenus.find(e=>e.selected).name : ''}}
						<img src="images/view-off.png" alt="노출안함" v-if="selectedBoard && selectedBoard.hideEnable"/>
					</div>
				</div>
				
				<!-- 링크 이동 --> <!-- 컴포넌트 분리 필요 -->
				<div class="title-box m-b-30 clearfix">
					링크: {{link}}
					<a class="btn-sm btn-blue round" :href="moveLink" target="_blank" title="새창열림">이동하기</a>
				</div>

				<div class="white-box m-t-10 clearfix">

					<!-- 제목 --> <!-- 컴포넌트 분리 필요 -->
					<p
						class="f-18 m-b-15 m-t-10 text-bold text-blue" 
						:style="{'color': `${article.nameColor} !important`}" 
					>
						{{article.title}}
					</p>

					<!-- 공지 설정, 분류, 작성자, 작성일, 조회  --> 
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<b>공지 설정 : </b>{{article.noticeEnable ? "설정 함" : "설정 하지 않음"}}
						</span>
						<span class="input-group-addon text-left">
							<b>분류 : </b> {{article.articleCategoryNm || "미분류"}}
						</span>
						<span class="input-group-addon text-left">
							<b>작성자 :</b> {{article.mber && article.mber.mberName || article.name}}{{article.mberId && `(${article.mberId})`|| ""}}
						</span>
						<span class="input-group-addon text-left">
							<b>작성일 :</b> {{article.regDate}}
						</span>
						<span class="input-group-addon text-left">
							<b>조회 :</b> {{ article.lookupCount }}
						</span>
					</div>
					<div class="on-border round m-t-10 m-b-10" style="padding: 40px 2rem;" >
						<div style="width: 866px" v-html="article.content"></div>
					</div>
					<!-- 첨부파일 다운로드 --> <!-- 컴포넌트 분리 필요 -->
					<ul class="m-b-10" v-if="article.articleFileMappingList.length">
						<li v-for="mapping in article.articleFileMappingList" :key="`article-file-${mapping.atchFileId}`">
							<a class="down-btn" :href="`/download/${mapping.atchFileId}`" target="_blank" title="새창열림">
								{{mapping.file.orignlFileNm}} {{'('+numberFormat(Math.ceil(mapping.file.fileMg/1024))+'KB)'}}
							</a>
						</li>
					</ul>

				</div>
				
				<!-- 댓글 --> <!-- 컴포넌트 분리 필요 -->
				<template>
					<!-- 댓글 작성 폼-->
					<div class="white-box m-t-10 clearfix">
						<p class="f-14 m-b-5">댓글</p>
						<textarea class="full-width" cols="30" rows="2" v-model="newComment"></textarea>
						<button class="btn-sm round pull-right" @click="postComment">댓글달기</button>
						<div v-if="!article.commentList || !article.commentList.length">작성된 댓글이 없습니다.</div>
					</div>
					<!-- 댓글 불러오기 및 수정/삭제 -->
					<div class="white-box m-t-10 clearfix" v-if="article.commentList && article.commentList.length">
						<div class="comment" v-for="comment in article.commentList" :key="`comment-${comment.commentId}`">
							<p class="m-b-0 clearfix">
								{{comment.mberId}} ｜ {{comment.regDate}}
								<!-- 버튼 메서드 부여 -->
								<span class="pull-right" v-if="!modifyingComment || modifyingComment.commentId!=comment.commentId">
									<a class="modify" @click="setModifyingComment(comment)"></a>
									<a class="del" @click="deleteComment(comment)"></a>
								</span>
								<!-- 수정 버튼 활성화-->
								<span class="pull-right" v-else-if="modifyingComment && modifyingComment.commentId==comment.commentId">
									<button class="btn-sm round pull-right" @click="patchComment">수정완료</button>
									<button class="btn-sm round pull-right" @click="modifyCommentCancel">취소</button>
								</span>
							</p>
							<!-- 댓글 내용 -->
							<div 
								v-if="!modifyingComment || modifyingComment.commentId!=comment.commentId" 
								class="bg-lightgray p-15" style="line-height: 1.4;" 
								v-html="comment.content ? comment.content.replace(/\n/g, '<br>') : ''"
							></div>
							<!-- 댓글 내용 수정 폼 -->
							<textarea 
								v-else-if="modifyingComment && modifyingComment.commentId==comment.commentId" 
								class="full-width" 
								cols="30" rows="2" 
								v-model="modifyingComment.content"
							></textarea>
						</div>
					</div>
				</template>

				<!-- 이전글, 다음글 -->
				<table class="table2 table-bordered text-center" >
					<tbody>
						<tr>
							<td class="w100 bg-deepblue text-white">이전</td>
							<td v-if="nextArticle">
								<a @click="routerArticleNext" title="이전 글로 이동하기">{{nextArticle.title}}</a>
							</td>
							<td v-else>
								<span>이전 글이 없습니다.</span>
							</td>
						</tr>
						<tr>
							<td class="w100 bg-deepblue text-white">다음</td>
							<td v-if="prevArticle">
								<a @click="routerArticlePrev" title="다음 글로 이동하기">{{prevArticle.title}}</a>
							</td>
							<td v-else>
								<span>다음 글이 없습니다.</span>
							</td>
						</tr>
					</tbody>
				</table>

				<!-- 버튼 메서드 부여 -->
				<button class="btn btn-darkgray round m-t-30 m-b-30 pull-left" type="button" @click="routerArticleList">목록</button>
				<!-- <button v-if="$route.params.boardId==5" class="btn btn-darkgray round m-t-30 m-b-30 pull-left" type="button" @click="sendNotification">알림보내기 ({{eventListenerCount}}명)</button> -->
				<button class="btn btn-blue round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="routerArticleReply" v-if="articleCreate">답글쓰기</button>
				<button class="btn btn-blue round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="routerArticleModify" v-if="articleUpdate">수정</button>
				<button class="btn btn-red round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="deleteArticle" v-if="articleDelete && trashBoardId === parseInt($route.params.boardId)">삭제</button>
				<button class="btn btn-red round m-t-30 m-b-30 m-r-5 pull-right" @click="tempDeleteArticle" v-if="articleDelete && trashBoardId !== parseInt($route.params.boardId)">휴지통</button>
			</section>
		</section>

		<!-- <modal-note :config="modals.ModalNote" @close="modals.ModalNote.show=false;" :key="hash(modals.ModalNote)" @onDone="onDone"></modal-note> -->
		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
/**
 * TODO: 상세보기 권한 체크해야할 부분
 * 게시판 조회 (사이드 메뉴 리스트)
 * 
 * 게시물 조회 (본문, 본문 > 이전, 본문 > 다음)
 * 게시물 수정 (본문 하단)
 * 게시물(답글) 등록 (본문 하단)
 * 
 * 댓글 조회 (본문)
 * 댓글 수정 (본문)
 * 댓글 삭제 (본문)
 */
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
// import ModalNote from '../modals/ModalNote.vue'

import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명
	name: 'ViewBoardDetail',
	mixins: [fnAdjustHeight],
	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert,
		// ModalNote,
	},
	mounted: function() {
		this.getBoardList();
		this.getArtcle();
		this.getPreNextArticle();
		this.getAuthInfo().then((auth) => {
			if(auth['관리자 권한']['게시판관리: 게시물 등록'] && auth['관리자 권한']['게시판관리: 게시물 등록']['permission']) {
				this.articleCreate = true;
			}
			if(auth['관리자 권한']['게시판관리: 게시물 삭제'] && auth['관리자 권한']['게시판관리: 게시물 삭제']['permission']) {
				this.articleDelete = true;
			}
			if(auth['관리자 권한']['게시판관리: 게시물 수정'] && auth['관리자 권한']['게시판관리: 게시물 수정']['permission']) {
				this.articleUpdate = true;
			}
		});
	},
	data: function() {
		return {
			menus : [
				{name:'게시물 목록',link:"/board",selected:true},
			],
			buttons : [
			],
			sideButtons: [],
			sideMenus: [],

			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				// ModalNote: ModalNote.default()
			},
			keyword: this.$route.query.keyword,
			pageSize: this.$route.query.pageSize || 30,
			offset: this.$route.query.offset || 0,

			articleCreate: false,
			articleDelete: false,
			articleUpdate: false,

			trashBoardId : server.trashBoardId || null,

			selectedBoard: null,
			article: null,
			nextArticle: null,
			prevArticle: null,

			link: "",
			moveLink: "",
			
			newComment: "",
			modifyingComment: null,
			eventListenerCount: 0
		}
	},
	methods: {
		routerArticleList: function() {
			const { article, offset, pageSize, keyword } = this;
			this.$router.push(`/board/${article.boardId}${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`);
		},
		routerArticleReply: function() {
			const { article } = this;
			this.$router.push(`/board/${article.boardId}/write/${article.articleId}`);
		},
		routerArticleModify: function() {
			const { article, offset, pageSize, keyword } = this;
			this.$router.push(`/board/${article.boardId}/detail/${article.articleId}/modify${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`);
		},
		routerArticlePrev: function() {
			const { prevArticle, keyword } = this;
			this.$router.push(`/board/${prevArticle.boardId}/detail/${prevArticle.articleId}${keyword && `?keyword=${keyword}` || ''}`);
		},
		routerArticleNext: function() {
			const { nextArticle, keyword } = this;
			this.$router.push(`/board/${nextArticle.boardId}/detail/${nextArticle.articleId}${keyword && `?keyword=${keyword}` || ''}`);
		},
		getBoardList: async function() {
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.BOARD}`, { lecId: 0 });
				const { trashBoardId } = this;
				let { boardId } = this.$route.params;
				let trashBoardInfo = "";
				this.sideMenus = data.list.map(e => {
					const info = {
						board: e,
						selected: e.boardId === parseInt(boardId),
						name: e.boardName,
						hideEnable: e.hideEnable || 0,
						link: `/board/${e.boardId}`
					}
					if(!boardId) { // !! boardId = 0인 게시판은 없다. , 게시판 번호가 없을 때, 상단을 클릭
						this.selectedBoard = e;
						boardId = e.boardId;
						this.$router.push(`/board/${e.boardId}`);
					}
					if(e.boardId === parseInt(boardId)) { // selectedBoard 선택
						this.selectedBoard = e;
						// this.link = `board.html?state=1&lecId=${e.lecId}&boardId=${e.boardId}`;
						// this.moveLink =`${server.addr()}/${server.hostParentName}/${this.link}`;
					}
					if(trashBoardId && trashBoardId === e.boardId) trashBoardInfo = info; // 휴지통 정보 저장
					return info;
				}).filter(e => parseInt(e.board.boardId) !== trashBoardId); // 휴지통 게시판 제외
				if(trashBoardId) this.sideMenus = [...this.sideMenus, trashBoardInfo]; // 휴지통 하단으로 내리기
			} catch(e) {e}
		},
		getArtcle: async function() {
			try {
				const { articleId } = this.$route.params;
				const { data } = await Axios.post(`${server.addr()}${server.api.ARTICLE}/${articleId}`);

				this.article = data.return ? data.return : {};
				this.article.nameColor = this.article.noticeEnable ?  "#f08300" : "";
				this.link = `board.html?state=2&boardId=${this.article.boardId}&articleId=${this.article.articleId}`;
				this.moveLink =`${server.addr()}/${server.hostParentName}/${this.link}`;
			} catch(e) { e }
		},
		getPreNextArticle: async function() {
			try {
				const { keyword } = this;
				const { boardId, articleId } = this.$route.params;
				const { data } = await Axios.post(`${server.addr()}${server.api.PRENEXT_ARTICLE}/${boardId}/${articleId}`, {
					boardId, keyword, orderBy: "reg_date"
				});
				this.nextArticle = data.return.nextArticle;
				this.prevArticle = data.return.prevArticle;
			} catch(e) { e }
		},
		postComment: async function() {
			try {
				if(this.newComment) {
					await Axios.put(`${server.addr()}${server.api.COMMENT}`, [{
						articleId: this.article.articleId,
						content: this.newComment
					}]);
					this.newComment = "";
					this.getArtcle();
				}
			} catch(e) { e }
		},
		deleteArticle: function() {
			this.modals.ModalConfirm.msg = "게시물을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				const { articleId } = this.$route.params;
				Axios.delete(`${server.addr()}${server.api.ARTICLE}/${articleId}`).then(() => {
					this.modals.ModalConfirm.show = false;
					this.routerArticleList();
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		tempDeleteArticle: async function() {
			this.modals.ModalConfirm.msg = "게시물을 휴지동으로 이동 하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "확인";
			this.modals.ModalConfirm.btnYes.fn = () => {
				const { articleId } = this.$route.params;
				Axios.patch(`${server.addr()}${server.api.ARTICLE}/${articleId}`, {
						boardId : server.trashBoardId
					}).then(() => {
						this.$emit("onDone", "휴지통으로 이동 되었습니다.");
						this.routerArticleList();
					})
			}
			this.modals.ModalConfirm.show = true;
		},
		setModifyingComment: function(comment) {
			this.modifyingComment = JSON.parse(JSON.stringify(comment));
		},
		modifyCommentCancel: function() {
			this.modifyingComment = null;
		},
		patchComment: function() {
			Axios.patch(`${server.addr()}${server.api.COMMENT}/${this.modifyingComment.commentId}`, this.modifyingComment).then(() => {
				this.modifyingComment = null;
				this.getArtcle();
			})
		},
		deleteComment: function(comment) {
			this.modals.ModalConfirm.msg = "댓글을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				Axios.delete(`${server.addr()}${server.api.COMMENT}/${comment.commentId}`).then(() => {
					this.getArtcle();
					this.modals.ModalConfirm.show = false;
				});
			}
			this.modals.ModalConfirm.show = true;
		},
		sendNotification: function() { /** @deprecated */
			Axios.post(server.addr()+server.api.EVENT,{articleId:this.$route.params.articleId}).then(response => {
				let sendList = response.data.list;
				if(sendList.length==0) {
					this.modals.ModalAlert.msg = "쪽지를 수신할 대상이 없습니다.";
					this.modals.ModalAlert.show = true;
					return;
				}
				this.modals.ModalNote.sendList = sendList;
				this.modals.ModalNote.show = true;
			})
		},
		onDone: function(message) { /** @deprecated */
			this.modals.ModalAlert.msg = message;
			this.modals.ModalAlert.show = true;
		},
		numberFormat: function(inputNumber) {
			if (!inputNumber) return 0;
			return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>
